interface I18Next {
  t: typeof import('i18next')['t'];
}

const __i18next: I18Next = {
  t: k => k,
};

export default __i18next;

export const i18next = __i18next;

// 延时加载
// import('i18next').then(mod => __i18next.t = (...params) => mod.default.t(...params));

